// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-table {
  width: 100%;
  border-collapse: collapse;
}

.mat-mdc-row,
.mat-mdc-header-row {
  height: 35px;
  white-space: nowrap;
}

.mat-mdc-header-cell {
  font-weight: bold;
  padding: 0 1em 0 1em;
}

.mat-mdc-cell {
  padding: 0 1em 0 1em;
  font-size: 12px;
}

.mat-mdc-button {
  min-width: 0px;
  width: 18px;
  padding: 0px;
}

.input {
  padding-top: 11px;
  width: 100%;
  box-sizing: border-box;
}

addContainer {
  flex: fit-content;
}

.header {
  padding: 10px 0;
  align-items: baseline;
}

.headerText {
  text-transform: capitalize;
  display: block;
  font-size: 20px;
  font-weight: bold;
}

.addContainer {
  justify-content: space-between;
  margin-bottom: 20px;
}

.addForm {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  margin-right: 10px;
}

.addInput {
  max-width: 200px;
  margin-top: 5px;
  margin-bottom: 5px;
}

/* (mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
  height: 28px;
  font-size: 14px;
  padding: 5px;
}

/* (mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
::ng-deep .mat-form-field-infix {
  border-top: 0px;
}

.editInput {
  margin-top: 5px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.spacer {
  display: block;
  height: 20px;
}

.icon {
  font-size: 18px;
}

.buttonDiv {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  gap: 10px;
  row-gap: 10px;
}

.emptyMessage {
  text-align: center;
  font-style: italic;
  font-size: 12px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/homepage/homepage-editor/homepage-editor.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,0BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA,6HAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA,6HAAA;AACA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AACF;AACA,w/GAAw/G","sourcesContent":[".mat-mdc-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.mat-mdc-row,\n.mat-mdc-header-row {\n  height: 35px;\n  white-space: nowrap;\n}\n\n.mat-mdc-header-cell {\n  font-weight: bold;\n  padding: 0 1em 0 1em;\n}\n\n.mat-mdc-cell {\n  padding: 0 1em 0 1em;\n  font-size: 12px;\n}\n\n.mat-mdc-button {\n  min-width: 0px;\n  width: 18px;\n  padding: 0px;\n}\n\n.input {\n  padding-top: 11px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\naddContainer {\n  flex: fit-content;\n}\n\n.header {\n  padding: 10px 0;\n  align-items: baseline;\n}\n\n.headerText {\n  text-transform: capitalize;\n  display: block;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.addContainer {\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.addForm {\n  display: flex;\n  justify-content: space-between;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.addInput {\n  max-width: 200px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n/* (mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\n::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n  height: 28px;\n  font-size: 14px;\n  padding: 5px;\n}\n\n/* (mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\n::ng-deep .mat-form-field-infix {\n  border-top: 0px;\n}\n\n.editInput {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  line-height: 1.5;\n}\n\n.spacer {\n  display: block;\n  height: 20px;\n}\n\n.icon {\n  font-size: 18px;\n}\n\n.buttonDiv {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n  gap: 10px;\n  row-gap: 10px;\n}\n\n.emptyMessage {\n  text-align: center;\n  font-style: italic;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
